import { useTLang } from 'intl/intl';

export function useSFDeleteItemConfirmLang() {
  return {
    title: useTLang({ id: 'substitutionFlow.043' }),
    description: useTLang({ id: 'substitutionFlow.044' }),
    action: {
      cancelBtn: useTLang({ id: 'substitutionFlow.045' }),
      confirmBtn: useTLang({ id: 'substitutionFlow.046' }),
    },
  };
}
